import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import ButtonWithIcons from 'components/_new/Button/ButtonWithIcons/ButtonWithIcons'

import s from './SocialButton.scss'
import messages from './messages'


const SocialButton = ({ className, type, disabled, ...rest }) => {
  const rootClassName = cx(className, s.root, s[type], {
    [s.disabled]: disabled,
  })

  const title = messages[type]

  return (
    <ButtonWithIcons
      className={rootClassName}
      title={title}
      leftIcon={type}
      color={null}
      weight="medium"
      {...rest}
    />
  )
}

SocialButton.propTypes = {
  type: PropTypes.oneOf([ 'facebook', 'google' ]).isRequired,
  disabled: PropTypes.bool,
}

SocialButton.defaultProps = {
  disabled: false,
}


export default SocialButton
